/**
 * 사이트 currency(₩, $, ¥, ₺, KRW, USD …) → ISO 코드/분기를 정규화한다.
 */

export function normalizeFiatCurrencyCode (currency) {
  const raw = String(currency || '').trim()
  if (!raw) return 'USD'
  const code = raw.toUpperCase()

  if (raw === '₩' || code === 'KRW' || code === 'WON' || raw === '원') return 'KRW'
  if (raw === '$' || code === 'USD' || code === 'USDT') return 'USD'
  if (raw === '¥' || raw === '￥' || code === 'JPY' || code === 'YEN' || raw === '円') return 'JPY'
  if (raw === '€' || code === 'EUR' || code === 'EURO') return 'EUR'
  if (raw === '£' || code === 'GBP') return 'GBP'
  if (raw === '₺' || code === 'TRY' || code === 'TL' || code === 'TUR') return 'TRY'
  if (code === 'CNY' || code === 'RMB' || raw === '元' || raw === '人民币') return 'CNY'
  if (code === 'VND') return 'VND'
  if (code === 'THB') return 'THB'
  if (code === 'PHP') return 'PHP'

  if (/^[A-Z]{3}$/.test(code)) return code
  return code || 'USD'
}

export function isKrwCurrency (currency) {
  return normalizeFiatCurrencyCode(currency) === 'KRW'
}

export function isUsdCurrency (currency) {
  return normalizeFiatCurrencyCode(currency) === 'USD'
}

/** 금액 입력 placeholder용 예시 숫자 (화폐 스케일에 맞춤) */
export function resolveAmountPlaceholderValue (currency) {
  const code = normalizeFiatCurrencyCode(currency)
  if (code === 'KRW') return 100000
  if (code === 'JPY' || code === 'VND') return 10000
  if (code === 'USD' || code === 'EUR' || code === 'GBP' || code === 'TRY') return 100
  if (code === 'CNY' || code === 'THB' || code === 'PHP') return 1000
  return 100
}
